import { Box, Container } from "@material-ui/core";
import React from "react";
// import { useStakingContract, useTokenContract } from "../hooks";

export default function Summary({
  staked,
  unstaked,
  withdrwan,
  reward,
  currentStaked,
  earned,
  balance,
}) {
  return (
    <Box position="relative">
      <Container maxWidth="lg">
        <Box
          component="h3"
          fontSize={{ xs: "30px", sm: "50px" }}
          textAlign="center"
          color="#fff"
          mt={30}
          mb={10}
          p={0}
        >
          Your Statistics
        </Box>
        <Box
          borderRadius={{ xs: "20px", sm: "59px" }}
          align="cneter"
          width={{ xs: "100%", sm: "100%", md: "80%" }}
          mx="auto"
          mt={10}
          p={{ xs: 2, sm: 2 }}
          boxShadow=" 0px 0px 23px 2px rgba(255, 255, 255, 0.144)"
          style={{
            background: "rgb(0, 0, 0, 0.1 )",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
          >
            <Box
              bgcolor="#101010"
              border="1px solid #444"
              width={{ xs: "100%", sm: "45%" }}
              height="405px"
              mx="auto"
              borderRadius="20px"
              p={1}
              my={2}
            >
              <Box
                bgcolor="rgba(255, 255, 255, 0.144)"
                border="1px solid #444"
                borderRadius="20px"
                width="100%"
                height="45%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                p={2}
                mb={2}
              >
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "18px", sm: "25px" }}
                  textAlign="center"
                >
                  LEDU Earned
                </Box>
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "18px", sm: "25px" }}
                  textAlign="center"
                >
                  {parseInt(+earned).toFixed(2)}
                </Box>
              </Box>
              <Box
                bgcolor="rgba(255, 255, 255, 0.144)"
                border="1px solid #444"
                height="50%"
                borderRadius="20px"
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "14px", sm: "24px" }}
                  width={{ xs: "100%", sm: "45%" }}
                  textAlign="center"
                >
                  Claimed Reward
                  <Box
                    fontWeight={700}
                    color="#fff"
                    fontSize={{ xs: "18px", sm: "30px" }}
                    textAlign="center"
                  >
                    {(+reward).toFixed(0)}
                  </Box>
                </Box>
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "14px", sm: "24px" }}
                  textAlign="center"
                  width={{ xs: "100%", sm: "45%" }}
                >
                  Current Staked
                  <Box
                    fontWeight={700}
                    color="#fff"
                    fontSize={{ xs: "18px", sm: "30px" }}
                    textAlign="center"
                  >
                    {(+currentStaked).toFixed(0)}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              bgcolor="#101010"
              border="1px solid #444"
              width={{ xs: "100%", sm: "45%" }}
              height="405px"
              mx="auto"
              borderRadius="20px"
              p={2}
              my={2}
            >
              <Box
                bgcolor="rgba(255, 255, 255, 0.144)"
                border="1px solid #444"
                borderRadius="20px"
                width="100%"
                height="45%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                p={4}
                mb={3}
              >
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "18px", sm: "25px" }}
                  textAlign="center"
                >
                  Your LEDU Wallet Balance
                </Box>
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "18px", sm: "25px" }}
                  textAlign="center"
                >
                  {+balance.toFixed(2)}
                </Box>
              </Box>
              <Box
                bgcolor="rgba(255, 255, 255, 0.144)"
                border="1px solid #444"
                height="50%"
                borderRadius="20px"
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "14px", sm: "24px" }}
                  width={{ xs: "100%", sm: "45%" }}
                  textAlign="center"
                >
                  Total Staked
                  <Box
                    fontWeight={700}
                    color="#fff"
                    fontSize={{ xs: "18px", sm: "30px" }}
                    textAlign="center"
                  >
                    {(+staked).toFixed(0)}
                  </Box>
                </Box>
                <Box
                  fontWeight={700}
                  color="#fff"
                  fontSize={{ xs: "14px", sm: "24px" }}
                  textAlign="center"
                  width={{ xs: "100%", sm: "45%" }}
                >
                  Total UnStaked
                  <Box
                    fontWeight={700}
                    color="#fff"
                    fontSize={{ xs: "18px", sm: "30px" }}
                    textAlign="center"
                  >
                    {(+unstaked).toFixed(0)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
